import { createReducer, on } from "@ngrx/store";
import { initialEmpresaActualState } from "../../core/interfaces/models/empresa-actual.interface";
import { addEmpresaActual, addEmpresaActualError, clearEmpresaActual, updateEmpresaActual } from "../actions/empresa-actual.actions";

export const empresaActualReducer = createReducer(
  initialEmpresaActualState,
  on(addEmpresaActual, (_, { empresaActualState }) => (
    empresaActualState
  )),
  on(addEmpresaActualError, (state, { debugMessage }) => ({
    ...state,
    error: true,
    debugMessage
  })),
  on(updateEmpresaActual, (state, { empresaActual }) => ({
    ...state,
    empresaActual: empresaActual
  })),
  on(clearEmpresaActual, () => initialEmpresaActualState)
);



/*
export const empresaReducer = createReducer(
  initialEmpresaState,

  on(addEmpresa, (state, { empresa }) => ({
    ...state,
    empresa: empresa,
  })),

  on(addEmpresaError, (state) => ({
    ...state,
    error: true,
  })),

  on(deleteEmpresaError, (state) => ({
    ...state,
    error: false,
  })),


  on(deleteEmpresa, () => initialEmpresaState),

  on(updateEmpresa, (state, { empresa }) => ({
    ...state,
    empresa: empresa
  })),

);
*/